import React from 'react';
import { EmptyState } from './EmptyState';
import gettext from '@eb/gettext';
import { NoResultsIllustration as NoResultsIllustrationSvg } from '@eb/eds-iconography';

const getCopyPhysical = (currentPlace) =>
    gettext(
        'We couldn’t find any events from this organizer in %(placeName)s. Try updating your location to find more options.',
        { placeName: currentPlace },
    );

export const NoResults = (props) => {
    let copy = gettext(
        'Nothing matched your search, but you might like these options.',
    );

    if (props.isOrganizationsSearch) {
        copy = getCopyPhysical(props.currentPlace);

        if (props.isOnlineSearch) {
            copy = gettext(
                'We couldn’t find any online events from this organizer. Try updating your location to find more options.',
            );
        }
    }

    return (
        <EmptyState illustrationType={<NoResultsIllustrationSvg />} {...props}>
            {copy}
        </EmptyState>
    );
};
